import React from 'react';
import { Helmet } from 'react-helmet';
import { COMPANY } from '../content/company';
import { FAQ_CLOSING, FAQ_GROUPS, FAQ_HERO, FAQ_META } from '../content/faq';
import { NAV_CTA } from '../content/nav';
import MarketingLayout from '../layout/MarketingLayout';
import Button from '../primitives/Button';
import FaqAccordion from '../sections/FaqAccordion';

/**
 * /faq: a text hero, five numbered groups of accordions, and on desktop a
 * compact index of the groups beside them. No search at this length. Every
 * answer is in the HTML whether or not it is open.
 */
export default function FaqPage() {
  return (
    <MarketingLayout activePage="faq" waitlistPopup>
      <Helmet>
        <title>{FAQ_META.title}</title>
        <meta name="description" content={FAQ_META.description} />
        <link rel="canonical" href={`${COMPANY.siteUrl}/faq`} />
      </Helmet>

      <section className="mk-faq">
        <div className="mk-container">
          <div className="mk-faq__hero">
            <p className="t-details t-muted">{FAQ_HERO.eyebrow}</p>
            <h1 className="mk-faq__title t-display">{FAQ_HERO.heading}</h1>
            <p className="mk-faq__lede t-body">{FAQ_HERO.body}</p>
          </div>

          <div className="mk-faq__layout">
            <nav className="mk-faq__index" aria-label="Question groups">
              <ol>
                {FAQ_GROUPS.map((group) => (
                  <li key={group.id}>
                    <a href={`#faq-${group.id}`}>
                      <span className="mk-faq__group-num t-details">{group.numeral}</span>
                      <span className="t-body">{group.title}</span>
                    </a>
                  </li>
                ))}
              </ol>
            </nav>

            <div>
              {FAQ_GROUPS.map((group) => (
                <section key={group.id} id={`faq-${group.id}`} className="mk-faq__group" aria-labelledby={`faq-${group.id}-title`}>
                  <div className="mk-faq__group-head">
                    <span className="mk-faq__group-num t-details" aria-hidden="true">
                      {group.numeral}
                    </span>
                    <h2 id={`faq-${group.id}-title`} className="t-details">
                      {group.title}
                    </h2>
                  </div>
                  <FaqAccordion items={group.items} />
                </section>
              ))}

              <div className="mk-faq__cta">
                <h2 className="t-headline">{FAQ_CLOSING.heading}</h2>
                <p className="t-body">{FAQ_CLOSING.body}</p>
                <div className="mk-closing__actions">
                  <Button variant="fill" href={`mailto:${COMPANY.email}`}>
                    {FAQ_CLOSING.primary}
                  </Button>
                  <Button variant="link" to={NAV_CTA.to}>
                    {FAQ_CLOSING.secondary}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </MarketingLayout>
  );
}
